import { signActions } from "./sign-slice";
import { uiActions } from "../ui-slice";

export const GetSigns = (email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Cargando información",
        message: "Se esta solicitando la información al servidor.",
      })
    );
    const GetSignsInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetSignsInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSigns({
            signs: response.data.map((sign) => {
              return {
                ...sign,
                status: sign.status === true ? "Activo" : "Inactivo",
              };
            }),
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSigns({
            statues: [],
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};

export const GetSign = (pk, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando firma",
        message: "Solicitando firma al servidor.",
      })
    );
    const getSignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/validateDigitalSign`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Pk: pk,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el firma",
        })
      );
    }
  };
};
export const UpdateSign = (sign, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando firma",
        message: "Solicitando Actualización del firma al servidor.",
      })
    );
    const updateSignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/sign/update`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: sign.id,
            Name: sign.name,
            City: sign.city,
            Countryid: sign.countryid,
            Address: sign.address,
            Email: sign.email,
            Ra: sign.ra,
            ZipCode: sign.zipCode,
            Identifier: sign.identifier,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Firma Actualizado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar el firma",
        })
      );
    }
  };
};

export const CreateSign = (sign, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando firma",
        message: "Solicitando Creación del firma al servidor.",
      })
    );
    const createSignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/sign/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Name: sign.name,
            City: sign.city,
            Countryid: sign.countryid,
            Address: sign.address,
            Email: sign.email,
            Ra: sign.ra,
            ZipCode: sign.zipCode,
            Identifier: sign.identifier,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Firma Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear el firma",
        })
      );
    }
  };
};

export const StartSigning = (Sign, email, isIntern) => {

  
  
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Enviando los archivos",
        message: "Solicitando Creación de la firma al servidor.",
      })
    );

    let formData = new FormData();
    formData.append("BelongingId", Sign.BelongingId);
    formData.append("RepresentativeId", Sign.RepresentativeId);
    formData.append("Profile", "PFnubeQABAPerteneciente");
    formData.append("IsIntern", isIntern);

    for (let i = 0; i < Sign.files.length; i++) {
      const element = Sign.files[i];
      formData.append("Files", element);
    }

    formData.append("UserName", email);

    const createSignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/startSigning`,
        {
          method: "POST",
          headers: {
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
          body: formData,
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear la firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Archivo enviado exitosamente",
            message: response.result.message,
          })
        );
        window.location.href = "/"
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo enviar el archivo",
        })
      );
    }
  };
};

export const StartOnboarding = (pk, email) => {
  return async (dispatch) => {
    const getSignInfo = async () => {  
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/startOnboarding`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Pk: pk,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      
      if (!response.ok) {
        throw new Error("No se pudo obtener el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setOnboardingUrl({
            onboardingStartUr: response.data,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el firma",
        })
      );
    }
  };
};

export const ResendOnboarding = (pk, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando firma",
        message: "Solicitando firma al servidor.",
      })
    );
    const getSignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/senOnboardingAgain`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Pk: pk,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el firma",
        })
      );
    }
  };
};

export const ActiveSign = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Activando firma",
        message: "Solicitando activación del firma al servidor.",
      })
    );
    const activeSignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/sign/active`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo activar el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await activeSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Firma Activado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo activar el firma",
        })
      );
    }
  };
};

export const InactiveSign = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando firma",
        message: "Solicitando activación del firma al servidor.",
      })
    );
    const inactiveSignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/sign/inactive`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo inactivar el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await inactiveSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Firma Inactivado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo inactivar el firma",
        })
      );
    }
  };
};

export const RevokeSign = (pk, email, reason, comment) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando firma",
        message: "Solicitando activación del firma al servidor.",
      })
    );
    const inactiveSignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/revokeDigitalSign`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            pk: pk,
            Reason: reason,
            Comment: comment,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo inactivar el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await inactiveSignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Firma Inactivado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo inactivar el firma",
        })
      );
    }
  };
};

export const DenySign = (email, pk, reason) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando firma",
        message: "Solicitando activación del firma al servidor.",
      })
    );
    const denySignInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/cancelDigitalSign`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Pk: pk,
            Reason: reason,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo denegar el firma");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await denySignInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          signActions.setSign({
            sign: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Firma denegada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          signActions.setSign({
            sign: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {

      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo denegar el firma",
        })
      );
    }
  };
};

